import styled from 'styled-components';

export const ClassicCheckoutDivider = styled.div`
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 16px 0;
`;
